<template>
  <vs-popup class="link-sage-customer-pop-up"
            id="popup"
            :title="`LINK TO EXISTING SAGE CUSTOMER (${company_name})`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickLinkSageCustomer)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="sage_id" name="sage_id" rules="required" v-slot="{ errors }">
                <small class="label">Sage customers</small>
                <v-select :clearable="false" label="name" v-model="createForm.sage_id" :reduce="option => option.id" :options="sage_customers" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  @search="onSearch">
                  <template v-slot:option="option">
                    <span>{{option.name}} - {{option.reference}} </span>
                  </template>
                  <template slot="no-options">
                  type to search sage customer
                </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8 mb-0">
            <vs-button button="submit" class="ml-auto mt-2">Create</vs-button>
            <vs-button @click="open = false" class="ml-4 mt-2" type="border" color="warning">Close</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SageRepository = RepositoryFactory.get('sage')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import SageHelper from '@/mixins/SageHelper'

  function initialState() {
    return {
      open: false,
      customer_id: '',
      company_name: '',
      createForm: {},
      sage_customers: []
    }
  }

export default {
  name: 'LinkSageCustomerPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (customer_id, company_name) {
      try {
        await Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.customer_id = customer_id
        this.company_name = company_name
        this.open = true;
      } catch (error) {

      }
    },
    async onClickLinkSageCustomer () {
      const vue = this;
      this.$vs.loading()
       try {
         await SageRepository.linkSageCustomer(this.customer_id, this.createForm)
         this.showSuccessMessage('Sage customer linked successfully')
         await vue.$parent.loadCustomerDetails()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    onSearch: function (search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: _.debounce( async (loading, search, vm) => {
      try {
        vm.sage_customers =  (await SageRepository.getSageCustomers(`filter[name]=${search}`)).data.data
      } catch (e) {
        this.sageAuthHandler(e.response.status)
      }
      loading(false);
    }, 350),
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages, SageHelper],
}
</script>

<style scoped>
  .link-sage-customer-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 40% !important;
  }
</style>
